/** Where a landing request stands, on either phone. */
export const RequestState = {
    /** Sent, no answer yet. */
    sent: "sent",
    /** The mentor said yes; the newcomer has not confirmed yet. */
    offered: "offered",
    /** Confirmed: the mentor link is open. */
    linked: "linked",
    /** The mentor said no. */
    declined: "declined",
    /** The newcomer closed it because another link opened, or the request was blocked. */
    closed: "closed",
};
/** Who wrote a note on a mentor link, as this phone sees it. */
export const NoteFrom = { me: "me", them: "them" };
//# sourceMappingURL=types.js.map